/* Slick Slider home banner*/

jQuery(document).ready(function ($) {
	//var firstSlide = Math.floor(Math.random() * 6);
	var firstSlide = 2;
    // videos
	/*$('.c-hover-newbanner').on('init', function (event, slick) {
		$("div[data-slick-index='" + firstSlide + "']").find('video').get(0).play();
	});*/    
	$('.c-hover-newbanner').slick({
		autoplay: true,
		useTransform: true,
		autoplaySpeed: 7500,
		speed: 500,
		pauseOnHover: false,
		pauseOnFocus: false,
		arrows: false,
		dots: true,
		fade: false,
		slidesToShow: 1
		/*initialSlide: firstSlide*/
	});

    //videos
    /*
	$('.c-hover-newbanner').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
		if (document.body.clientWidth > 800)
			$('.c-hover-newbanner .slick-slide').parent().find($("div[data-slick-index='" + nextSlide + "']")).find('video').get(0).play();
	});*/
});